<!--
    @component
    Generates an SVG stacked bar chart and sets the color via an ordinal scale in `zScale`.
   -->
<script>
    // @ts-expect-error
    import guff from "dataset:../_data/guff.aml";
    import { fade } from "svelte/transition";

    /** @type {number} */
    export let window_width;
    /** @type {string} */
    export let us_east;
    /** @type {string} */
    export let us_west;
</script>

<div class:full-size-reset-wrapper={window_width <= 500}>
    <div
        class="html-map center"
        class:full-size-reset={window_width <= 500}
        class:full={window_width <= 500}
        transition:fade
    >
        <img
            loading="lazy"
            class="map-img"
            src={us_east}
            alt="{guff.img_alt_eastmap}"
        />

        <p>{@html guff.map_annotation3}</p>

        <p>{@html guff.map_annotation4}</p>

        <img
            loading="lazy"
            class="map-img"
            src={us_west}
            alt="{guff.img_alt_westmap}"
        />

        <p>{@html guff.map_annotation2}</p>
    </div>
</div>

<style lang="scss">
    .map-img {
        border: 0.5px solid var(--gray-30);
    }

    p {
        margin: var(--vert-rhythm-sm) 0;
        font-family: var(--fonts-serif);
    }

    .full-size-reset {
        @media (max-width: 500px) {
            .map-img {
                border: none;
            }

            p {
                margin-left: 1.44rem;
                margin-right: 1.44rem;
            }
        }

        // This should only happen if user JS is disabled/not yet loaded
        @media (min-width: 501px) {
            .map-img {
                // Half of screenshot px, which I *think* is optimal for retina
                max-width: 440px;
                margin: 0 auto;
            }

            p {
                max-width: 440px;
                // !important need to override svelte-specificity
                margin-left: auto !important;
                margin-right: auto !important;
            }
        }
    }
</style>
